import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.features.list-bill-matched-items.views.BillMatchedItemsTable`

export default defineMessages({
  tableAriaLabel: {
    id: `${scope}.tableAriaLabel`,
    defaultMessage: 'Matched items',
  },
  refColumn: {
    id: `${scope}.refColumn`,
    defaultMessage: 'Ref.',
  },
  descriptionColumn: {
    id: `${scope}.descriptionColumn`,
    defaultMessage: 'Description',
  },
  departmentColumn: {
    id: `${scope}.departmentColumn`,
    defaultMessage: 'Department',
  },
  accountColumn: {
    id: `${scope}.accountColumn`,
    defaultMessage: 'Account',
  },
  matchesColumn: {
    id: `${scope}.matchesColumn`,
    defaultMessage: '# of matches',
  },
  dateColumn: {
    id: `${scope}.dateColumn`,
    defaultMessage: 'Date',
  },
  lineCostColumn: {
    id: `${scope}.lineCostColumn`,
    defaultMessage: 'Line cost',
  },
  multipleLabel: {
    id: `${scope}.multipleLabel`,
    defaultMessage: 'Multiple',
  },
  totalCostLabel: {
    id: `${scope}.totalCostLabel`,
    defaultMessage: 'Total cost: {amount} {currency}',
  },
  emptyStateHeader: {
    id: `${scope}.emptyStateHeader`,
    defaultMessage: "There aren't any matched items",
  },
})
